import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'
import type { SortDir } from '../../lib/employeePerformance'

/** The arrow on a sortable heading in the Employee Performance tables — the widget's and its drill-down's. */
export default function SortIcon({ active, dir }: { active: boolean; dir: SortDir }) {
    const Icon = !active ? ArrowUpDown : dir === 'asc' ? ArrowUp : ArrowDown
    return <Icon size={12} aria-hidden="true" className="emp-perf-sort-icon" />
}
